// Pure helpers for the Records page.

// Render the record's distinct billable price levels ('ST', 'ST+OT', 'EACH',
// 'HOL', ...) — the backend's rate_levels string, shown verbatim so a new
// price level can never masquerade as another (the old 3-bit code rendered
// its "anything not ST/OT" bucket as 'HOL', so PREM/VAC/EACH per-diem lines
// all displayed as holiday).
export function renderRateMix(levels, status) {
  // Gaps never reach the push path so rate-mix is meaningless for them.
  // Everything else (including 'failed') was billable when queued, so
  // show the actual mix.
  if (status === 'gap') {
    return <span style={{ color: '#bbb' }}>—</span>;
  }
  if (!levels) return <span style={{ color: '#bbb' }}>—</span>;
  const hasOt = levels.split('+').includes('OT');
  return (
    <span style={{ color: hasOt ? '#FF6600' : '#002159', fontWeight: 600 }}>{levels}</span>
  );
}

// Display name for a record status. Internal keys are unchanged ('pushed'
// stays the API/DB value and the badge CSS class); only what the user reads
// says "synced" (tab + button renamed 2026-06-12).
const STATUS_LABELS = {
  pushed: 'synced',
  manually_handled: 'manually handled',
};

export function statusLabel(status) {
  return STATUS_LABELS[status] || status;
}

// Stable signature for a Set used in dependency arrays. The Set identity
// changes every render even when its contents don't; signature comparison
// prevents fetch loops in useEffect/useCallback.
export function setSignature(s) {
  if (!s || s.size === 0) return '';
  return Array.from(s).sort().join(',');
}
